module.exports = __webpack_public_path__ + "img/1.12a1acb3.svg";